import { types } from '../types/types';

const initialState = {
	listUserRoleModules:[],
	userRoleModulesSave:[],

};

export const userRoleModuleReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.USERROLEMODULE_START_REGISTER_LIST:
			return {
				...state,
				userRoleModulesSave: action.payload,
			};

		case types.USERROLEMODULE_GET_LIST_MODULES:
			return {
				...state,
				listUserRoleModules: action.payload,
			};

		default:
			return state;
	}
};
